import SmazzoStesa from "./SmazzoStesa";

// La Baraja Española (40 carte: Oros, Copas, Espadas, Bastos) usa dritto + rovescio:
// stessa fisica reale del caos degli altri mazzi (stessa infrastruttura, mazzo reale).
export default function Baraja() {
  return <SmazzoStesa deck="baraja" />;
}
